import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { SaveButtonComponent } from '../save-button/save-button.component';

@Component({
  selector: 'app-save-and-cancel-buttons',
  templateUrl: './save-and-cancel-buttons.component.html',
  styleUrls: ['./save-and-cancel-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NzButtonModule, SaveButtonComponent],
})
export class SaveAndCancelButtonsComponent {
  @Output() save = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() anyClick = new EventEmitter();

  onSaveClick() {
    this.save.emit();
    this.anyClick.emit();
  }

  onCancelClick() {
    this.cancel.emit();
    this.anyClick.emit();
  }
}
